<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs2></v-flex>
      <v-flex xs8>
        <v-alert type="info" :value="weAreClosed">
          <p>{{ selectedDayComment }}</p>
        </v-alert>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="step > 1">
              Pick up
            </v-stepper-step>
            <v-stepper-step step="2" :complete="step > 2">
              Items
            </v-stepper-step>
            <v-stepper-step step="3" :complete="step > 3">
              Schedule
            </v-stepper-step>
            <v-stepper-step step="4">
              Confirm Cost
            </v-stepper-step>
          </v-stepper-header>
          <connection-manager ref="connectionManager" v-model="connecting">
          </connection-manager>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card>
                <v-card-text>
                  <!--Origin-->
                  <google-place-input
                    id="origin"
                    country="KE"
                    :clearable="false"
                    :courier="true"
                    :allowToShowMapSnippet="true"
                    :disabled="connecting"
                    :enable-geolocation="true"
                    label="Enter pickup location"
                    placeholder="Pickup location"
                    prepend-icon="edit_location"
                    :required="true"
                    :load-google-api="false"
                    :value="originInput"
                    ref="originInput"
                    :hint="originFormattedAddress"
                    persistent-hint
                    :hide-details="false"
                    types='["geocode",]'
                    v-on:placechanged="onOriginEntered"
                  >
                  </google-place-input>
                  <v-text-field
                    label="Enter address details"
                    placeholder="Address details E.g. Company Name, Floor name, Contact name, Contact phone"
                    v-model="addressDetails"
                    required
                    :rules="[rules.required]"
                    prepend-icon="edit_location"
                  >
                  </v-text-field>
                  <v-select
                    v-model="driverId"
                    :items="drivers"
                    hide-details
                    class="mb-1"
                    item-text="details"
                    item-value="id"
                    label="Select a Truck"
                    placeholder="Truck"
                  >
                  </v-select>
                  <guide
                    text="Please provide location where item or items will be collected"
                  ></guide>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat @click.native="onClose(false)" color="red">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="connecting && !courierOptions.length"
                    :disabled="!originPosition || connecting || invalidForm"
                    @click.native="goStepTwo"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card-text>
                <!--items-->
                <v-list
                  two-line
                  :style="
                    'max-height: ' + $vuetify.breakpoint.height * 0.4 + 'px; '
                  "
                  class="scroll-y"
                >
                  <template v-for="(item, index) in items">
                    <v-list-tile avatar :key="index">
                      <v-list-tile-avatar>
                        <img :src="$app.imageUrl(item.courierOption.icon)" />
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="body-2">
                          <b
                            >{{ item.quantity }} -
                            {{
                              item.quantity === 1
                                ? item.courierOption.name
                                : item.courierOption.pluralName
                            }}</b
                          >
                          <!-- - {{item.distance/1000}}km-->
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="primary--text caption">
                          <b> To: </b>{{ item.destinationName }} -
                          {{ item.destinationFormattedAddress }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-menu bottom right offset-y>
                          <v-btn slot="activator" light icon>
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list dense>
                            <!--<v-list-tile @click="editItem(item, index)">Edit</v-list-tile>-->
                            <v-list-tile @click="deleteItem(item, index)"
                              >Delete</v-list-tile
                            >
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index !== items.length - 1"
                      inset
                      :key="index + items.length"
                    ></v-divider>
                  </template>
                </v-list>
                <add-delivery-item-dialog
                  :show="addingItem"
                  :originPosition="originPosition"
                  @onAddItem="onAddItem"
                  :courierOptions="courierOptions"
                  @onClose="addingItem = false"
                >
                </add-delivery-item-dialog>
                <v-btn
                  block
                  :loading="calculatingDirections"
                  flat
                  color="primary"
                  @click.native=";(addingItem = true), (isAnEdit = false)"
                  :disabled="connecting || calculatingDirections"
                >
                  <v-icon left dark>add </v-icon>
                  Add item
                  <span slot="loader">Please wait...</span>
                </v-btn>
                <guide text="Add one or more items"></guide>
              </v-card-text>
              <v-card>
                <v-card-actions>
                  <v-btn flat :disabled="connecting" @click.native="step = 1">
                    <v-icon left>arrow_back</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    :disabled="connecting"
                    @click.native="onClose(false)"
                    color="red"
                    >Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!items.length"
                    @click.native="step = 3"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs10 offset-xs1 v-if="!weAreClosed">
                      <guide :text="weDeliverText"></guide>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-subheader>Schedule</v-subheader>
                      <date-input
                        v-model="scheduleDate"
                        :disabled="connecting"
                        :default-value="currentDate"
                        placeholder="Pick up date"
                        :allowedDates="allowedDates"
                      >
                      </date-input>
                      <v-select
                        v-model="scheduleTime"
                        :items="pickupTimes"
                        label="Pick up time"
                        prepend-icon="access_time"
                      >
                      </v-select>
                      <v-alert
                        type="error"
                        :value="invalidTime && !weAreClosedForTheDay"
                      >
                        <p>{{ invalidTimeErrorMessage }}</p>
                      </v-alert>
                      <v-alert type="info" :value="weAreClosedForTheDay">
                        <p>{{ selectedDayComment }}</p>
                      </v-alert>
                      <guide
                        text="Our rider will pickup your delivery at the earliest time possible"
                      ></guide>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions>
                  <v-btn flat :disabled="connecting" @click.native="step = 2">
                    <v-icon left>arrow_back</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    :disabled="connecting"
                    @click.native="onClose(false)"
                    color="red"
                    >Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="connecting || invalidTime || weAreClosed"
                    @click.native="step = 4"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs8 offset-xs2>
                      <v-icon x-large class="mb-3">
                        account_balance_wallet
                      </v-icon>
                      <v-btn block color="primary" outline large flat>
                        Total Cost Estimate:

                        <span class="ml-1">
                          <b> {{ $app.formatMoney(estimatedCost) }}</b></span
                        >
                      </v-btn>
                      <v-checkbox
                        v-model="urgent"
                        class="mt-3"
                        :disabled="connecting"
                        label="This is an urgent delivery"
                      >
                      </v-checkbox>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <p
                            color="secondary"
                            v-if="totalDiscount > 0"
                            v-on="on"
                          >
                            Total Saving:
                            <span class="ml-1"
                              ><b>
                                {{ $app.formatMoney(totalDiscount) }}</b
                              ></span
                            >
                          </p>
                        </template>
                        <span
                          >The more you delivery you book the more you
                          save.</span
                        >
                      </v-tooltip>
                      <guide :text="timeEstimationMessage"></guide>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-btn flat :disabled="connecting" @click.native="step = 3">
                    <v-icon left>arrow_back</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    :disabled="connecting"
                    @click.native="onClose(false)"
                    color="red"
                    >Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="connecting || calculatingDeliveryCost"
                    @click.native="submit"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
      <v-flex xs2></v-flex>
    </v-layout>
    <v-dialog v-model="showTopUpDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Insufficient Balance</v-card-title>
        <v-card-text>
          {{ errorText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="showTopUpDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn color="green darken-1" flat="flat" @click="navigateToTopUp()"
            >Top Up Your Account
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable no-undef */

import GooglePlaceInput from './GooglePlaceInput'
import EventBus from '../event-bus'
import Guide from './Guide'
import ConnectionManager from './ConnectionManager'
import AddDeliveryItemDialog from './AddDeliveryItemDialog'
import moment from 'moment'
import DateInput from './DateInput'
import TimeInput from './TimeInput'
import { mapMutations } from 'vuex'

export default {
  name: 'AddDelivery',
  components: {
    TimeInput,
    DateInput,
    AddDeliveryItemDialog,
    ConnectionManager,
    Guide,
    GooglePlaceInput
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialog: false,
      addingItem: false,
      connecting: false,
      step: 1,
      originInput: '',
      errorText: '',
      originName: null,
      driverId: null,
      drivers: [],
      originFormattedAddress: null,
      originVicinity: null,
      originPosition: {},
      isAnEdit: false,
      currentHour: moment().hour(),
      currentMinutes: moment().minute(),
      items: [],
      addressDetails: null,
      showTopUpDialog: false,
      courierOptions: [],
      costVariables: [],
      selectedItem: null,
      selectedItemIndex: -1,
      directionsService: new google.maps.DirectionsService(),
      calculatingDirections: false,
      scheduleDate: null,
      scheduleTime: null,
      calculatingDeliveryCost: false,
      estimatedCost: 0,
      urgent: false,
      weAreClosed: false,
      openTime: 8,
      closeTime: 19,
      itemWithLongestDistance: null,
      totalTime: 0,
      operationHours: [],
      rules: {
        required: value => !!value || 'Required.'
      },
      invalidTimeErrorMessage:
        "Pickup time should be between 8a.m and 7p.m and can't be lower than the current time",
      selectedDayComment: '',
      totalDiscount: 0
    }
  },
  computed: {
    weAreClosedForTheDay() {
      return this.weAreClosed
    },
    weDeliverText() {
      return `We are delivering between ${moment(this.openTime, 'HH:mm').format(
        'HH:mm'
      )} and ${moment(this.closeTime, 'HH:mm').format('HH:mm')}`
    },
    allowedDates() {
      let that = this
      return {
        dates: function(date) {
          let givenDate = moment(date, 'YYYY/MM/DD')
          if (that.currentHour > that.closeTime + 1 && that.currentHour <= 23) {
            return givenDate.diff(moment(), 'days', true) > 0
          }
          if (moment().isSame(givenDate, 'day')) {
            return true
          }
          return givenDate.diff(moment(), 'days', true) >= 0
        }
      }
    },
    pickupTimes() {
      let currentSelectedDate = moment(this.scheduleDate, 'YYYY/MM/DD')
      if (!this.checkIfClosedForThisDay(this.scheduleDate)) {
        var startTime = this.currentHour
        var endTime = this.closeTime
        // selectedTime.isBefore(expectedClosingTime, 'minutes')
        if (
          (startTime >= 0 && startTime <= 7) ||
          currentSelectedDate.isAfter(moment())
        ) {
          startTime = this.openTime
        } else {
          startTime = startTime + 1
        }
        var hours, minutes
        const times = []
        for (var i = startTime; i <= endTime; i += 1) {
          hours = i
          if (i === startTime && currentSelectedDate.day() === moment().day()) {
            minutes = this.currentMinutes
          } else {
            minutes = 0
          }
          if (minutes < 10) {
            minutes = '0' + minutes // adding leading zero to minutes portion
          }
          if (hours < 10) {
            hours = '0' + hours // adding leading zero to hours portion
          }
          times.push(hours + ':' + minutes)
        }
        this.scheduleTime = times[0]
        return times
      } else {
        return []
      }
    },
    invalidTime: function() {
      return false
    },
    currentDate() {
      return moment().format('YYYY-MM-DD')
    },
    invalidForm: function() {
      return !this.addressDetails || !this.driverId
    },
    timeEstimationMessage() {
      if (this.urgent) {
        return `Your delivery will take a maximum of ${this.timeConvert(
          this.totalTime
        )} after pickup`
      } else {
        return 'Your delivery will take a maximum of 4 hours after pickup'
      }
    }
  },
  watch: {
    show(val) {
      this.dialog = !!val
    },
    step(val) {
      if (val && val === 4) {
        //
        if (this.items.length > 0) {
          this.getEstimatedCostFromServer()
        }
      }
    },
    urgent(val) {
      if (this.items.length > 0) {
        this.getEstimatedCostFromServer()
      }
    },
    originPosition(val) {
      if (this.items.length > 0) {
        let itemsCopy = [...this.items]
        this.items = []
        for (let item of itemsCopy) {
          this.onAddItem(item)
        }
      }
      this.$app.log(JSON.stringify(val))
    }
  },
  methods: {
    checkIfClosedForThisDay(theDay) {
      this.weAreClosed = false
      this.selectedDayComment = ''
      var found = false
      this.operationHours.forEach(currentHour => {
        if (currentHour.day === theDay) {
          this.openTime = currentHour.openTime
          this.closeTime = currentHour.closeTime
          if (currentHour.status === 'CLOSED') {
            this.selectedDayComment = currentHour.comment
            this.weAreClosed = true
          } else {
            this.selectedDayComment = currentHour.comment
            this.weAreClosed = false
          }
          found = true
        }
      })
      if (found) {
        return this.weAreClosed
      } else {
        this.setOperationHours()
        return this.weAreClosed
      }
    },
    setOperationHours() {
      if (this.operationHours && this.operationHours.length > 0) {
        let allDayOperationHours = this.operationHours[0]
        if (allDayOperationHours.status === 'CLOSED') {
          this.weAreClosed = true
          this.selectedDayComment = allDayOperationHours.comment
        } else {
          this.openTime = allDayOperationHours.openTime
          this.closeTime = allDayOperationHours.closeTime
        }
      }
    },
    getOperationsHours() {
      //
      let that = this
      this.$refs.connectionManager.get(
        'operationHours',
        {
          onSuccess(response) {
            //
            that.operationHours = response.data.data
          },
          onFailure(err) {
            that.$app.log(err)
            that.weAreClosed = true
          }
        },
        {}
      )
    },
    navigateToTopUp() {
      let route = this.$router.resolve({ name: 'topUp' })
      window.open(route.href, '_blank')
      this.showTopUpDialog = false
    },
    getEstimatedCostFromServer() {
      this.calculatingDeliveryCost = true
      this.axios
        .post('calculateDeliveryCost', {
          urgent: this.urgent,
          originName: this.originName,
          addressDetails: this.addressDetails,
          driverId: this.driverId,
          originVicinity: this.originVicinity,
          originFormattedAddress: this.originFormattedAddress,
          originLatitude: this.originPosition.lat,
          originLongitude: this.originPosition.lng,
          scheduleDate: this.scheduleDate,
          scheduleTime: this.scheduleTime,
          items: this.getDeliveryItems(),
          maintenance: 'maintenance'
        })
        .then(response => {
          let responseData = response.data.data
          // this.items = responseData.items
          this.estimatedCost = responseData.estimatedCost
          this.totalTime = responseData.totalTime
          this.totalDiscount = responseData.totalDiscount
          this.itemWithLongestDistance = responseData.itemWithLongestDistance
        })
        .catch(err => {
          this.$app.log(err)
        })
        .then(() => {
          this.calculatingDeliveryCost = false
        })
    },
    timeConvert(totalTimeInMinutes) {
      var num = totalTimeInMinutes
      var hours = num / 60
      var rhours = Math.floor(hours)
      var minutes = (hours - rhours) * 60
      var rminutes = Math.round(minutes)
      return rhours > 0
        ? rhours + ' hour(s) and ' + rminutes + ' minute(s)'
        : rminutes + ' minute(s)'
    },
    startInterval() {
      const that = this
      setInterval(function() {
        if (that.currentHour !== moment().hour()) {
          that.currentHour = moment().hour()
          if (that.currentHour > 18) {
            if (
              moment().isSame(moment(that.scheduleDate, 'YYYY/MM/DD'), 'day')
            ) {
              that.scheduleDate = moment()
                .add(1, 'days')
                .format('YYYY-MM-DD')
            }
          }
          that.currentMinutes = moment().minute()
        }
      }, 300000)
    },
    ...mapMutations({
      setSelectedItem: 'setSelectedItem'
    }),
    onOriginEntered(addressData, placeResultData) {
      this.originFormattedAddress = placeResultData.formatted_address
      this.originVicinity = placeResultData.vicinity
      this.originName = placeResultData.name
      this.originPosition = {
        lat: placeResultData.geometry.location.lat(),
        lng: placeResultData.geometry.location.lng()
      }
      EventBus.$emit('onOriginChanged', this.originPosition)
    },
    onClose(successful) {
      this.step = 1
      this.originPosition = null
      this.originFormattedAddress = null
      this.originVicinity = null
      this.note = null
      this.urgent = false
      this.scheduleDate = null
      this.scheduleTime = null
      this.items = []
      this.itemWithLongestDistance = null
      this.addingItem = false
      this.isAnEdit = false
      this.$refs.originInput.clear()
      this.$emit('onClose', successful)
    },
    onAddItem(item, isAnEdit) {
      this.addingItem = false
      this.isAnEdit = false
      this.calculatingDirections = true
      let that = this
      let waypts = []
      for (let stop of item.stops) {
        waypts.push({
          location: stop.stop_formatted_address,
          stopover: true
        })
      }
      this.directionsService.route(
        {
          origin: this.originPosition.lat + ',' + this.originPosition.lng,
          destination:
            item.destinationPosition.lat + ',' + item.destinationPosition.lng,
          waypoints: waypts,
          optimizeWaypoints: false,
          travelMode: 'DRIVING'
        },
        function(result, status) {
          if (status === 'OK') {
            item.distance = 0
            item.duration = 0
            for (let leg of result.routes[0].legs) {
              item.distance = item.distance + leg.distance.value
              item.duration = item.duration + leg.duration.value
            }
            // if (that.originPosition.lat === item.destinationPosition.lat && that.originPosition.lng === item.destinationPosition.lng) {
            //   item.distance = item.distance * 2
            // }
            that.items.push(item)
            that.calculatingDirections = false
            that.$app.log('The total distance is: ' + JSON.stringify(item))
          } else {
            that.$app.log('Directions request failed due to ' + status)
          }
        }
      )
    },
    editItem(item, index) {
      this.setSelectedItem(item)
      this.selectedItem = item
      this.selectedItemIndex = index
      this.addingItem = true
      this.isAnEdit = true
    },
    deleteItem(item, index) {
      this.items.splice(index, 1)
    },
    getDeliveryItems() {
      let deliveryItems = []
      for (let item of this.items) {
        deliveryItems.push({
          destinationName: item.destinationName,
          destinationVicinity: item.destinationVicinity,
          destinationFormattedAddress: item.destinationFormattedAddress,
          destinationLatitude: item.destinationPosition.lat,
          destinationLongitude: item.destinationPosition.lng,
          destinationPosition: item.destinationPosition,
          estimatedDistance: item.distance,
          estimatedDuration: item.duration,
          distance: item.distance,
          duration: item.duration,
          fragileOrPerishable: item.fragileOrPerishable,
          stops: item.stops,
          note: item.note,
          itemTotalDeliveryCost: item.itemTotalDeliveryCost,
          recipientContact: item.recipientContact,
          recipientName: item.recipientName,
          quantity: item.quantity,
          containerized: item.containerized,
          container: item.container,
          weight: item.weight,
          width: item.width,
          height: item.height,
          breadth: item.breadth,
          courierOptionId: item.courierOption.id,
          courierOption: item.courierOption
        })
      }
      return deliveryItems
    },
    submit() {
      this.error = false
      // let estimatedCost = Math.ceil(this.estimatedCost)
      let that = this
      this.$refs.connectionManager.post(
        '/bookDeliveryFromExternal',
        {
          onSuccess(response) {
            that.onClose(true)
            EventBus.$emit(that.$actions.addedDelivery)
            that.$app.log(response)
            const filter = 'pendingApproval'
            that.$router.push({ name: 'courier', params: { filter } })
          },
          onFailure(error) {
            if (error.response) {
              if (error.response.status === 422) {
                let errorMetaCode = error.response.data.meta.code
                if (errorMetaCode === 'INSUFFICIENT_BALANCE') {
                  that.errorText = error.response.data.meta.message
                  that.showTopUpDialog = true
                  //
                }
              }
            }
          }
        },
        {
          urgent: this.urgent,
          originName: this.originName,
          addressDetails: this.addressDetails,
          driverId: this.driverId,
          originVicinity: this.originVicinity,
          originFormattedAddress: this.originFormattedAddress,
          originLatitude: this.originPosition.lat,
          originLongitude: this.originPosition.lng,
          scheduleDate: this.scheduleDate,
          scheduleTime: this.scheduleTime,
          items: this.getDeliveryItems(),
          maintenance: 'maintenance'
        }
      )
    },
    goStepTwo() {
      if (!this.courierOptions.length) {
        let that = this
        // Load courier options
        this.$refs.connectionManager.get(
          '/courierOptions',
          {
            onSuccess(response) {
              that.$app.log(response.data.data)
              that.$app.log(response.data.variables)
              that.costVariables = response.data.costVariables
              that.courierOptions = that.courierOptions.concat(
                response.data.data
              )
              that.step = 2
            }
          },
          { withCostVariables: true }
        )
      } else {
        this.step = 2
      }
    },
    getRiders() {
      let that = this
      this.$refs.connectionManager.get('riders', {
        onSuccess(response) {
          that.drivers = response.data.data
          that.getOperationsHours()
        }
      })
    }
  },
  mounted() {
    this.getRiders()
    this.scheduleDate = this.currentDate
    this.startInterval()
    EventBus.$on('onOriginChanged', payload => {})
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/AddDelivery.vue